module.exports = __webpack_public_path__ + "img/lcbj.30b11a21.png";